import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Gestión Documental y Acreditación',
      description: 'Ordenamos, verificamos y subimos la documentación de empresas, trabajadores y vehículos para habilitación en faena.',
      to: '/gestion-documental'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Auditorías de Cumplimiento HSE',
      description: 'Revisamos normativas, permisos, procedimientos y documentación crítica para detectar brechas y entregar planes corregidos.',
      to: '/auditorias'
    },
    {
      icon: 'ri-user-settings-line',
      title: 'Asesoría HSE Operacional',
      description: 'Acompañamos la operación en terreno, controlando cumplimiento, riesgos y requerimientos del mandante.',
      to: '/asesoria-terreno'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Sistemas de Gestión (ISO)',
      description: 'Implementamos, actualizamos y mejoramos sistemas basados en ISO 45001 y 14001.',
      to: '/sistemas-gestion'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Capacitación y Entrenamiento',
      description: 'Impartimos cursos legales obligatorios y entrenamientos operacionales para personal propio y contratistas.',
      to: '/capacitacion'
    }
  ];

  const whyChooseUs = [
    '10 años de experiencia profesional en HSE y operación.',
    'Experiencia comprobada asesorando a empresas en Chile y Latinoamérica.',
    'Enfoque práctico: soluciones rápidas, ordenadas y orientadas al cumplimiento.',
    'Especialistas en acreditación, gestión documental y soporte HSE operacional.',
    'Acompañamiento directo en terreno cuando la operación lo requiere.'
  ];

  return (
    <>
      <section id="servicios" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              Nuestros Servicios
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Soluciones <span className="text-teal-600">HSE Integrales</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              SafeLine es una consultora formada por profesionales con experiencia real en HSE, operación y gestión documental. Nuestro enfoque es práctico: entregar soluciones rápidas, ordenadas y efectivas que permitan a nuestros clientes operar con plena continuidad, cumpliendo normativa y manteniendo el control en terreno.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 border border-gray-200 hover:border-teal-300 hover:shadow-xl transition-all hover:-translate-y-1"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                  {service.description}
                </p>
                <Link
                  to={service.to}
                  className="text-teal-600 font-semibold text-sm inline-flex items-center gap-2 hover:gap-3 transition-all whitespace-nowrap rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500"
                >
                  Ver más
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-12">
            <div className="text-center mb-12">
              <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Por qué elegirnos
              </h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
              {whyChooseUs.map((reason, index) => (
                <div 
                  key={index}
                  className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 hover:bg-white/15 transition-all"
                >
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white text-lg"></i>
                    </div>
                    <p className="text-white text-sm leading-relaxed">
                      {reason}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-teal-600 to-teal-700">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
            ¿Necesitas apoyo inmediato en acreditación o cumplimiento? Habla con nosotros.
          </h3>
          <Link
            to="/contacto"
            className="bg-white text-teal-600 px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl hover:scale-105 inline-flex items-center gap-2 whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
          >
            Hablar con un asesor
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </section>
    </>
  );
}